export var ApplePayLineItemTypeObj = ["final", "pending"];
/** @internal */
export var validateApplePayLineItemType = function (applePayLineItemType) {
    return ApplePayLineItemTypeObj.includes(applePayLineItemType);
};
